module.exports = __webpack_public_path__ + "static/media/telegram.b37d6df3.png";